export const useHubspot = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const _hsq = typeof window !== 'undefined' && window._hsq ? window._hsq : []

  const setTrackPageView = () => {
    _hsq.push(['trackPageView'])
  }

  const setPathPageView = (path: string): void => {
    _hsq.push(['setPath', path])
  }

  const setIdentity = (email: string) => {
    _hsq.push(['identify', { email }])
  }

  const setRemoveCookie = () => {
    _hsq.push(['revokeCookieConsent'])
  }

  return {
    setTrackPageView,
    setPathPageView,
    setIdentity,
    setRemoveCookie
  }
}
